

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop, Watch} from "vue-property-decorator";
  import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
  import {IOnOffHandlers} from "bonomo/dist";
  import {namespace} from "vuex-class";
  import {IShortUser} from "@/model/shortInterfaces";
  import UserChip from "@/components/shared/chips/UserChip.vue";
  import CreateButton from "@/components/shared/CreateButton.vue";
  import {BetterSelectItem} from "@/model/betterVuetifyInterfaces";
  import UserSearch from "@/components/user/widget/UserSearch.vue";

  const serviceProviderUserModule = namespace("serviceProviderUserModule");

  @Component({
    components: {UserSearch, CreateButton, UserChip}
  })
  export default class SPUsers extends Vue {

    @Prop()
    protected provider!: IServiceProvider;
    @Prop()
    protected disabled!: boolean;
    @Prop()
    protected editing!: boolean;
    @Prop()
    protected viewing!: boolean;
    @Prop()
    protected canEdit!: boolean;

    @serviceProviderUserModule.Getter('owners')
    protected owners!: IShortUser[];
    @serviceProviderUserModule.Getter('operators')
    protected operators!: IShortUser[];

    @Watch('provider.id')
    spIdChanged() {
      this.loadData();
    }

    protected roleItems: BetterSelectItem[] = [
      { value: '301', text: this.$t('settings.permissions.permissions.301.title')},
      { value: '302', text: this.$t('settings.permissions.permissions.302.title')},
    ];

    protected adding: boolean = false;
    protected loading: boolean = false;
    protected addRole: number = 0;
    protected addUserId: number = 0;
    protected submitting: boolean = false;
    private subscribes: IOnOffHandlers = {};

    created() {
      this.loadData();
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.serviceProvidersUsersLoaded': this.onLoaded,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onRemoveOwner(userId: number) {
      this.submitting = true;
      this.$store.dispatch('serviceProviderUserModule/connectOwner', {
        serviceProviderId: this.provider.id,
        userId,
        connect: false
      });
    }

    protected onRemoveOperator(userId: number) {
      this.submitting = true;
      this.$store.dispatch('serviceProviderUserModule/connectOperator', {
        serviceProviderId: this.provider.id,
        userId,
        connect: false
      });
    }

    protected onUserSelected(user: IShortUser) {
      this.addUserId = user.id;
    }

    protected onAdd() {
      this.addUserId = 0;
      this.addRole = 0;
      this.adding = true;
    }

    protected onAddOK() {
      this.submitting = true;
      this.$store.dispatch(
          this.addRole == 301
            ? 'serviceProviderUserModule/connectOwner'
            : 'serviceProviderUserModule/connectOperator',
          {
            serviceProviderId: this.provider.id,
            userId: this.addUserId,
            connect: true
          }
      )
    }

    private loadData() {
      if (!this.provider || !this.provider.id) {
        return;
      }
      this.loading = true;
      this.$store.dispatch('serviceProviderUserModule/fetchServiceProvidersUsers', this.provider.id);
    }

    private onLoaded() {
      if (this.submitting) {
        this.$uiBus.emit('success', this.$t('common.saved'));
        this.submitting = false;
      }
      this.adding = false;
      this.loading = false;
    }

  }

